import type { FormPromoFields } from 'api/types/addresses.types';
import i18n from 'i18n/config';

export const PromoFields: FormPromoFields = {
  name: 'promocode',
  required: true,
  label: i18n.t('newOrderPage.promocode'),
  placeholder: i18n.t('newOrderPage.promoCodeHaveCoupon', 'Have a coupon ? Type it here'),
};
